import { TextBox } from '@homex/se-react-components';
import { CarouselItemId } from '@homex/se-widget-flow-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components/macro';
import { filterXSS } from 'xss';

import { setContainsXssInput, setRepairComments } from 'actions';
import { CarouselBottomButton } from 'components/CarouselBottomButton/CarouselBottomButton';
import { Phrase } from 'components/Phrase';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { INVALID_INPUT_MESSAGE, IState } from 'typings';
import { tryGetFlowCarouselItem } from 'utils/tryGetFlowCarouselItem';

import { Buttons, Container, FormGroup, Subhead } from './styles';

export const CAROUSEL_ITEM_ID = CarouselItemId.RepairComments;

export const CarouselItemRepairCommentsBottom = () => {
  const dispatch = useThunkDispatch();
  const { containsXssInput, flow, repairComments } = useSelector(
    (state: IState) => ({
      containsXssInput: state.userInput.containsXssInput,
      flow: state.client.flow,
      repairComments: state.userInput.repairComments,
    }),
  );

  const flowCarouselItem = tryGetFlowCarouselItem(flow, CAROUSEL_ITEM_ID);

  const { buttonType, customerLookupEnabled } = useTheme();

  const bottomButtonFormat = flow?.buttonType ?? buttonType;

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const preFilterText = event.currentTarget.value;
    dispatch(setRepairComments(preFilterText));

    if (preFilterText !== filterXSS(preFilterText)) {
      dispatch(setContainsXssInput(true));
    } else if (containsXssInput) {
      dispatch(setContainsXssInput(false));
    }
  };

  let destinationItemId;

  if (flowCarouselItem) {
    destinationItemId = flowCarouselItem.options.destinations.next;
  } else {
    destinationItemId = customerLookupEnabled
      ? CarouselItemId.CustomerLookup
      : CarouselItemId.RepairContactInfo;
  }

  const errorMsg = containsXssInput ? INVALID_INPUT_MESSAGE : undefined;

  return (
    <FormGroup>
      <Container>
        <Subhead>
          <Phrase id="REPAIR_COMMENTS.SUBHEAD" />
        </Subhead>
        <TextBox
          errorMessage={errorMsg}
          isMultiline={true}
          label={Phrase({ id: 'REPAIR_COMMENTS.LABEL' })}
          maxLength={300}
          onChange={handleChange}
          value={repairComments || ''}
        />
      </Container>
      <Buttons>
        <CarouselBottomButton
          buttonFormat={bottomButtonFormat}
          carouselItemId={CAROUSEL_ITEM_ID}
          destinationItemId={destinationItemId}
          isDisabled={containsXssInput}
        />
      </Buttons>
    </FormGroup>
  );
};
